export const bebidasFijas = [
    {
        tipo: "Agua Natural y Mineralizada",
        opciones: [
            { nombre: "Agua Embotellada", imagen: "/assets/bebidas/Agua.jpg" },
            { nombre: "Topo Chico Agua Mineral", imagen: "/assets/bebidas/TopoChico.jpg" },
            { nombre: "Ciel Agua Mineral", imagen: "/assets/bebidas/CielMineralizada.jpg" },
            { nombre: "Garci Crespo Agua Mineral", imagen: "/assets/bebidas/GarciCrespo.jpg" },
            { nombre: "Tehuacan", imagen: "/assets/bebidas/Tehuacan.jpg" },
            { nombre: "Peñafiel Agua Mineral", imagen: "/assets/bebidas/Peñafiel.jpg" }
        ]
    },
    {
        tipo: "Aguas de Sabor y Jugos",
        opciones: [
            { nombre: "Agua de Horchata", imagen: "/assets/bebidas/Horchata.jpg" },
            { nombre: "Agua de Jamaica", imagen: "/assets/bebidas/Jamaica.jpg" },
            { nombre: "Limonada Natural", imagen: "/assets/bebidas/LimonadaNatural.jpg" },
            { nombre: "Limonada Mineral", imagen: "/assets/bebidas/LimonadaMineral.jpg" },
            { nombre: "Naranjada Natural", imagen: "/assets/bebidas/Naranjada.jpg" },
            { nombre: "Naranjada Mineral", imagen: "/assets/bebidas/Naranjada.jpg" },
            { nombre: "Aguas Frescas", imagen: "/assets/bebidas/AguasFrescas.jpg" },
            { nombre: "Jugo de Manzana", imagen: "/assets/bebidas/JugosClasicos.jpg" },
            { nombre: "Jugos Clasicos", imagen: "/assets/bebidas/JugosClasicos.jpg" },
            { nombre: "Jugos Especialidades", imagen: "/assets/bebidas/JugosClasicos.jpg" },
            { nombre: "Jugos Naturales", imagen: "/assets/bebidas/JugosClasicos.jpg" }
        ]
    },
    {
        tipo: "Cafe y Te",
        opciones: [
            { nombre: "Cafe Americano", imagen: "/assets/bebidas/Americano.jpg" },
            { nombre: "Cafe Turco", imagen: "/assets/bebidas/CafeTurco.jpg" },
            { nombre: "Cafe Expresso", imagen: "/assets/bebidas/Expresso.jpg" },
            { nombre: "Espresso Doble", imagen: "/assets/bebidas/EspressoDoble.jpg" },
            { nombre: "Te", imagen: "/assets/bebidas/Te.jpg" },
            { nombre: "Cafe Capuccino", imagen: "/assets/bebidas/Capuchino.jpg" },
            { nombre: "Latte", imagen: "/assets/bebidas/Latte.jpg" },
            { nombre: "Chocolate Tradicional Frio", imagen: "/assets/bebidas/ChocolateFrio.jpg" },
            { nombre: "Frappe Capuchino", imagen: "/assets/bebidas/Frappe.jpg" },
            { nombre: "Frappe Moka", imagen: "/assets/bebidas/Frappe.jpg" }
        ]
    },
    {
        tipo: "Cervezas",
        opciones: [
            { nombre: "Clamato", imagen: "/assets/bebidas/Clamato.jpg" },
            { nombre: "Amstel Ultra", imagen: "/assets/bebidas/AmstelUltra.jpg" },
            { nombre: "Artesanal", imagen: "/assets/bebidas/CervezaArtesanal.jpg" },
            { nombre: "Barrilito", imagen: "/assets/bebidas/Barrilito.jpg" },
            { nombre: "Budlight", imagen: "/assets/bebidas/Budlight.jpg" },
            { nombre: "Colima", imagen: "/assets/bebidas/Colima.jpg" },
            { nombre: "Colima Cero Lager Ambar", imagen: "/assets/bebidas/ColimaCeroLagerAmbar.jpg" },
            { nombre: "Colima Cero Session IPA", imagen: "/assets/bebidas/ColimaCeroSession.jpg" },
            { nombre: "Corona Extra", imagen: "/assets/bebidas/Corona.jpg" },
            { nombre: "Corona Light", imagen: "/assets/bebidas/CoronaLight.jpg" },
            { nombre: "Heineken 0.0", imagen: "/assets/bebidas/Heineken.jpg" },
            { nombre: "Indio", imagen: "/assets/bebidas/Indio.jpg" },
            { nombre: "Laton Victoria", imagen: "/assets/bebidas/Victoria.jpg" },
            { nombre: "Michelob Ultra", imagen: "/assets/bebidas/MichelobUltra.jpg" },
            { nombre: "Modelo Dorada 0%", imagen: "/assets/bebidas/ModeloEspecialCero.jpg" },
            { nombre: "Modelo Especial", imagen: "/assets/bebidas/Modelo.jpg" },
            { nombre: "Negra Modelo", imagen: "/assets/bebidas/NegraModelo.jpg" },
            { nombre: "Pacifico", imagen: "/assets/bebidas/Pacifico.jpg" },
            { nombre: "Stella Artois", imagen: "/assets/bebidas/StellaArtois.jpg" },
            { nombre: "Tecate", imagen: "/assets/bebidas/Tecate.jpg" },
            { nombre: "Tecate Light", imagen: "/assets/bebidas/TecateLight.jpg" },
            { nombre: "Victoria", imagen: "/assets/bebidas/Victoria.jpg" },
            { nombre: "XX Lager", imagen: "/assets/bebidas/XX.jpg" },
            { nombre: "XX Ambar", imagen: "/assets/bebidas/XXAmbar.jpg" },
            { nombre: "Michelada Amstel Ultra", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Barrilito", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Budlight", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Colima", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Corona Extra", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Corona Light", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Heineken 0.0", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Indio", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Laton Victoria", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Michelob Ultra", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Modelo Dorada 0%", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Modelo Especial", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Negra Modelo", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Pacifico", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Stella Artois", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Tecate", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Tecate Light", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada Victoria", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada XX Ambar", imagen: "/assets/bebidas/Michelada.jpg" },
            { nombre: "Michelada XX Lager", imagen: "/assets/bebidas/Michelada.jpg" }
        ]
    },
    {
        tipo: "Cocteles",
        opciones: [
            { nombre: "Desarmador", imagen: "/assets/bebidas/Desarmador.jpg" },
            { nombre: "Mocktail Oriental", imagen: "/assets/bebidas/MocktailOriental.jpg" },
            { nombre: "Mocktail Tropical Havok", imagen: "/assets/bebidas/MocktailOriental.jpg" },
            { nombre: "Mocktail Patria", imagen: "/assets/bebidas/MocktailOriental.jpg" },
            { nombre: "St. Germain Spritz", imagen: "/assets/bebidas/Spritz.jpg" },
            { nombre: "Espresso Martini", imagen: "/assets/bebidas/EspressoMartini.jpg" },
            { nombre: "Aperol Spritz", imagen: "/assets/bebidas/AperolSpritz.jpg" },
            { nombre: "Negroni", imagen: "/assets/bebidas/Negroni.jpg" },
            { nombre: "Martini", imagen: "/assets/bebidas/MartiniSeco.jpg" },
            { nombre: "Moscow Mule", imagen: "/assets/bebidas/MoscowMule.jpg" },
            { nombre: "Mint Julep", imagen: "/assets/bebidas/MintJulep.jpg" },
            { nombre: "Pina Colada", imagen: "/assets/bebidas/PinaColada.jpg" },
            { nombre: "Tom Collins", imagen: "/assets/bebidas/TomCollins.jpg" },
            { nombre: "Margarita", imagen: "/assets/bebidas/Margarita.jpg" },
            { nombre: "Carajillo", imagen: "/assets/bebidas/Carajillo.jpg" },
            { nombre: "Perla Negra", imagen: "/assets/bebidas/PerlaNegra.jpg" },
            { nombre: "Old Fashioned", imagen: "/assets/bebidas/OldFashioned.jpg" },
            { nombre: "Mezcalita", imagen: "/assets/bebidas/Mezcalita.jpg" },
            { nombre: "Black Riot", imagen: null },
            { nombre: "Purple Trouble", imagen: "/assets/bebidas/PurpleTrouble.jpg" },
            { nombre: "Spicy Storm", imagen: "/assets/bebidas/SpicyStorm.jpg" },
            { nombre: "Gold Splash", imagen: null },
            { nombre: "Pink Stormy", imagen: "/assets/bebidas/PinkStormy.jpg" },
            { nombre: "Wild Disorder", imagen: null },
            { nombre: "Sweet Mayhem", imagen: "/assets/bebidas/SweetMayhem.jpg" },
            { nombre: "Sol y Sombra", imagen: "/assets/bebidas/SolySombra.jpg" },
            { nombre: "Spirit of the Jungle", imagen: null },
            { nombre: "Frozen Margarita", imagen: "/assets/bebidas/FrozenMargarita.jpg" },
            { nombre: "Dulce Tentacion", imagen: null },
            { nombre: "Yakulada", imagen: "/assets/bebidas/Yakulada.jpg" },
            { nombre: "Electric Lemonade", imagen: "/assets/bebidas/ElectricLemonade.jpg" },
        ]
    },
    {
        tipo: "Destilados",
        opciones: [
            { nombre: "Whiskey", imagen: "/assets/bebidas/Whiskey.jpg" },
            { nombre: "Vodka", imagen: "/assets/bebidas/Vodka.jpg" },
            { nombre: "Tequila Blanco", imagen: "/assets/bebidas/TequilaBlanco.jpg" },
            { nombre: "Tequila Anejo", imagen: "/assets/bebidas/TequilaAnejo.jpg" },
            { nombre: "Ron Blanco", imagen: "/assets/bebidas/RonBlanco.jpg" },
            { nombre: "Ron Anejo", imagen: "/assets/bebidas/RonAnejo.jpg" },
            { nombre: "Mezcal", imagen: "/assets/bebidas/Mezcal.jpg" }
        ]
    },
    {
        tipo: "Especialidades",
        opciones: [
            { nombre: "Caos in Red", imagen: null },
            { nombre: "Caos Blue Balls", imagen: null },
            { nombre: "Delirio Cremoso", imagen: null },
            { nombre: "Chamoyada", imagen: null },
            { nombre: "Azulito", imagen: null },
            { nombre: "Piñada Caos", imagen: null },
            { nombre: "Gomichela Mangomitas", imagen: null },
            { nombre: "Gomichela Chelarindo", imagen: null },
            { nombre: "Slush", imagen: null }
        ]
    },
    {
        tipo: "Malteada",
        opciones: [
            { nombre: "Malteada de Vainilla", imagen: "/assets/bebidas/Malteada.jpg" }
        ]
    },
    {
        tipo: "Refrescos",
        opciones: [
            { nombre: "Chaparritas", imagen: "/assets/bebidas/Chaparritas.jpg" },
            { nombre: "Snapple", imagen: "/assets/bebidas/Snapple.jpg" },
            { nombre: "Arizona", imagen: "/assets/bebidas/Arizona.jpg" },
            { nombre: "Boost", imagen: "/assets/bebidas/Boost.jpg" },
            { nombre: "Ginger Ale", imagen: "/assets/bebidas/GingerAle.jpg" },
            { nombre: "Soda Italiana", imagen: "/assets/bebidas/SodaItaliana.jpg" },
            { nombre: "Coca-Cola sin Azucar", imagen: "/assets/bebidas/Coca-ColaZero.jpg" },
            { nombre: "Coca-Cola Regular", imagen: "/assets/bebidas/Coca-Cola.jpg" },
            { nombre: "Coca-Cola Light", imagen: "/assets/bebidas/Coca-ColaLight.jpg" },
            { nombre: "Sprite", imagen: "/assets/bebidas/Sprite.jpg" },
            { nombre: "Sprite sin Azucar", imagen: "/assets/bebidas/SpritesinAzucar.jpg" },
            { nombre: "Fanta", imagen: "/assets/bebidas/Fanta.jpg" }
        ]
    },
    {
        tipo: "Vinos",
        opciones: [
            { nombre: "Vino Blanco", imagen: "/assets/bebidas/VinoBlanco.jpg" },
            { nombre: "Vino Espumoso", imagen: "/assets/bebidas/VinoEspumoso.jpg" },
            { nombre: "Vino Tinto", imagen: "/assets/bebidas/VinoTinto.jpg" },
            { nombre: "Vino Rosado", imagen: "/assets/bebidas/VinoRosado.jpg" }
        ]
    },
    {
        tipo: "Digestivos",
        opciones: []
    }

];